import React, { Component, Children } from 'react';
import * as PropTypes from 'prop-types';
import Tab from '@material-ui/core/Tab';
import classnames from 'classnames';

import Inputs from './Inputs';
import SimpleInputs from './SimpleInputs';
import Data from './Data';

const hiddenStyle = { display: 'none' };

const sanitizeRestProps = ({ label, icon, value, isSimpleInputs, ...rest }) => rest;

class FormTab extends Component {
  getComponent() {
    const { children, isSimpleInputs } = this.props;
    const firstElement = Children.count(children) === 1 ? children : children[0];
    if (isSimpleInputs || Inputs.includes(firstElement.type)) {
      return SimpleInputs;
    }
    return Data;
    // todo: also add some validation for Content children
  }

  renderHeader = ({ className, label, icon, value, ...rest }) => {
    return (
      <Tab
        key={label}
        label={label}
        value={value}
        icon={icon}
        className={classnames('form-tab', className)}
        {...sanitizeRestProps(rest)}
      />
    );
  };

  renderContent = rest => {
    const { children, basePath, record, resource, hidden, position } = rest;

    return (
      <span style={hidden ? hiddenStyle : null}>
        {React.createElement(this.getComponent(), { basePath, record, resource, position }, children)}
      </span>
    );
  };

  render() {
    const { children, context, ...rest } = this.props;
    return context === 'header' ? this.renderHeader(rest) : this.renderContent({ children, ...rest });
  }
}

FormTab.propTypes = {
  className: PropTypes.string,
  children: PropTypes.node,
  context: PropTypes.oneOf(['header', 'content']),
  hidden: PropTypes.bool,
  icon: PropTypes.element,
  label: PropTypes.string.isRequired,
  path: PropTypes.string,
  value: PropTypes.number,
  isSimpleInputs: PropTypes.bool,
};

FormTab.displayName = 'FormTab';

export default FormTab;
